// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('popover_selector_menu');

// eslint-disable-next-line @trello/no-module-logic, @typescript-eslint/no-explicit-any
export const PopoverSelectorMenuTemplate = t.renderable(({ isTemplate }: any) =>
  t.ul('.pop-over-list', function () {
    if (!isTemplate) {
      t.li(() =>
        t.a('.js-mem-selector', { href: '#' }, () =>
          t.format('members-ellipsis'),
        ),
      );
    }
    t.li(() =>
      t.a('.js-label-selector', { href: '#' }, () =>
        t.format('labels-ellipsis'),
      ),
    );
    return t.li(() =>
      t.a('.js-pos-selector', { href: '#' }, () =>
        t.format('position-ellipsis'),
      ),
    );
  }),
);
